// extracted by mini-css-extract-plugin
export default {"sectionDescription":"common__section-description__jCqf1","axnuiPreviewInputContainer":"common__axnui-preview-input-container__uOeE4"};